import React from 'react'
import PropTypes from 'prop-types'
import alignmentRed from '../assets/red-alignment.svg'
import brakesRed from '../assets/red-brakes.svg'
import shocksRed from '../assets/red-shocks.svg'
import tiresRed from '../assets/red-tires.svg'
import alignmentYellow from '../assets/yellow-alignment.svg'
import brakesYellow from '../assets/yellow-brakes.svg'
import shocksYellow from '../assets/yellow-shocks.svg'
import tiresYellow from '../assets/yellow-tires.svg'
import yellow_icon from "../assets/yellow_icon.svg";
import red_icon from "../assets/red_icon.svg";
import green_icon from "../assets/green_icon.svg";
import alignment_icon from "../assets/alignment_icon.svg";
import brakes_icon from "../assets/brakes_icon.svg";
import suspension_icon from "../assets/suspension_icon.svg";
import tires_icon from "../assets/tires_icon.svg";
import battery_icon from '../assets/battery_icon.svg'
import quote from '../assets/Quote.svg'
import invoice from '../assets/Invoice.svg'
import additional_notes from '../assets/Additional_Notes.svg'
import visit_documents from '../assets/visit_documents.svg'
import visit_report from '../assets/visit_report.svg'
import sh_invoice from '../assets/sh_invoice.svg'
import sh_quote from '../assets/sh_quote.svg'
import report from '../assets/report.svg'
import red_icon_with_notes from '../assets/red_icon_with_notes.png'
import green_icon_with_notes from '../assets/green_icon_with_notes.png'
import yellow_icon_with_notes from '../assets/yellow_icon_with_notes.png'

const CategoryIcon = ({category, sx = {}}) => {
  let css = "table-cell-img" ;
  let peppersCss = "w-8 ml-6 mr-2";
  const renderedIcon = () => {
    switch(category) {
      case "tires":
        return <img src={tires_icon} className={css} alt="tires_icon" style={{...sx}}/>
      case "suspension":
        return <img src={suspension_icon} className={css} alt="suspension_icon" style={{...sx}}/>
      case "brakes":
        return <img src={brakes_icon} className={css} alt="brakes_icon" style={{...sx}}/>
      case "alignment":
        return <img src={alignment_icon} className={css} alt="alignment_icon" style={{...sx}}/>
      case "Alignment":
        return <img src={alignment_icon} className={peppersCss} alt="alignment wheels" style={{...sx}}/>
      case "Battery":
        return <img src={battery_icon} className={css} alt="battery" style={{...sx}}/>
      case "Brakes":
        return <img src={brakes_icon} className={peppersCss} alt="brakes on wheel" style={{...sx}}/>
      case "Steering and Suspension Components":
        return <img src={suspension_icon} className={peppersCss} alt="shocks" style={{...sx}}/>
      case "Tires":
        return <img src={tires_icon} className={peppersCss} alt="tires" style={{...sx}}/>
      case "green": case "Green":
        return <img src={green_icon} className={css} alt="green_icon" style={{...sx}}/>
      case "yellow": case "Yellow":
        return <img src={yellow_icon} className={css} alt="Yellow_icon" style={{...sx}}/>
      case "red": case "Red":
        return <img src={red_icon} className={css} alt="red_icon" style={{...sx}}/>
      case "alignment Red":
        return <img src={alignmentRed} className={css} alt="alignment wheels" style={{...sx}}/>
      case "brakes Red":
        return <img src={brakesRed} className={css} alt="brakes on wheel" style={{...sx}}/>
      case "frontEndComponents Red":
        return <img src={shocksRed} className={css} alt="shocks" style={{...sx}}/>
      case "tires Red":
        return <img src={tiresRed} className={css} alt="tires" style={{...sx}}/>
      case "alignment Yellow":
        return <img src={alignmentYellow} className={css} alt="alignment wheels" style={{...sx}}/>
      case "brakes Yellow":
        return <img src={brakesYellow} className={css} alt="brakes on wheel" style={{...sx}}/>
      case "frontEndComponents Yellow":
        return <img src={shocksYellow} className={css} alt="shocks" style={{...sx}}/>
      case "tires Yellow":
        return <img src={tiresYellow} className={css} alt="tires" style={{...sx}}/>
      case "quote":
        return <img src={quote} className={css} alt="quote" style={{...sx}}/>
      case "invoice":
        return <img src={invoice} className={css} alt="invoice" style={{...sx}}/>
      case "additional":
        return <img src={additional_notes} className={peppersCss} alt="additional_notes" style={{...sx}}/>
      case "visit documents": 
        return <img src={visit_documents} className={css} alt="visit_documents" style={{...sx}}/>
      case "visit report":
        return <img src={visit_report} className={css} alt="visit_report" style={{...sx}}/>
      case "report": 
        return <img src={report} className={css} alt="report" style={{...sx}}/>
      case "sh invoice":
        return <img src={sh_invoice} className={css} alt="invoice" style={{...sx}}/>
      case "sh quote": 
        return <img src={sh_quote} className={css} alt="quote" style={{...sx}}/>
      case "red_notes": case "Red_notes":
        return <img src={red_icon_with_notes} className={css} alt="red notes" style={{...sx}}/>
      case "yellow_notes": case "Yellow_notes":
        return <img src={yellow_icon_with_notes} className={css} alt="yellow notes" style={{...sx}}/>
      case "green_notes": case "Green_notes":
        return <img src={green_icon_with_notes} className={css} alt="green notes" style={{...sx}}/> 
      default:  
    }
  }

  const icon = renderedIcon()

  return (
    <>
      {icon}
    </>
  )
}

CategoryIcon.propTypes = {
  category: PropTypes.string,
}

export default CategoryIcon